import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BaseLayout } from '@platzi/ui';
import { useWindowSize, SM_BREAKPOINT } from '@platzi/commons';
import { updateNextMaterial, createOrganizerLink, updateCourseProgress } from 'src/redux/actions';
import { getRouteProgress } from '../../../api';
import { PricingTable } from '../../../components/shared/PricingTable';
import { Header, Aside, Tabs } from '../';
import styles from './Layout.module.sass';

export const Layout = () => {
  const routeId = useSelector(state => state.get('route').get('id')) || 0;
  const [isMobile, setIsMobile] = useState(false);
  const { width: screenWidth } = useWindowSize();
  const dispatch = useDispatch();

  useEffect(() => {
    screenWidth < SM_BREAKPOINT ? setIsMobile(true) : setIsMobile(false);
  }, [screenWidth]);

  useEffect(() => {
    if(routeId === 0) return;

    getRouteProgress(routeId)
      .then(({data}) => {
        dispatch(updateNextMaterial(data.data.actual_organization_course));
        dispatch(updateCourseProgress(data.data.course_progress));
        dispatch(createOrganizerLink(data.data.edit_url));
      })
      .catch((err) => {
        throw new Error('::ERROR::ROUTES__LAYOUT', { cause: err });
      });
  }, []);

  return (
    <BaseLayout isDark>
      <div className={styles.Layout}>
        <div className="u-wrapper">
          <div className={styles.Columns}>
            <div>
              <Header />
              {isMobile && <Aside />}
              <Tabs />
            </div>
            {!isMobile && <Aside />}
          </div>
        </div>
      </div>
      <PricingTable />
    </BaseLayout>
  );
};
